module.exports = __webpack_public_path__ + "images/average-rating-blue-1a02633c.svg";